import {openDB} from 'idb';

export default class LocalDbService
{
    constructor()
    {
        this.defaultObjectStore = "gcReceipt";
        this.idb = {
            gcrDb: openDB("gcrDb", 1,{
                upgrade: (db, oldVersion, newVersion, transaction) => {
                    switch(oldVersion){
                        case 0:
                            
                             const store = db.createObjectStore('gcReceipt');
                             store.createIndex("offlineId", "offlineId", {unique: true});
                            // fall through so that we can upgrade.
                        case 1:
                            break;
                        default:
                            console.log("unknown db version");
                    }

                }
            })
        };
    }


    async fetchAllReceipts()
    {
        try
        {
            var resultData = await (await this.idb.gcrDb).getAll("gcReceipt");
            var res = resultData.map(offlineRec =>{
                var parsedRes = JSON.parse(offlineRec.ReceiptSnapshot);
                // add offline status fields
                parsedRes.identifiers = {id: offlineRec.transactionId, gcid: offlineRec.Gcid, status: offlineRec.status.flowStatus, statusReason: offlineRec.status.flowStatusReason} ;
                return parsedRes;
            });
            var result = {"httpStatusCode": "200", "hasError": false, "messages": ["local receipts fetched"], "dataResult": res};
            return result;
        }
        catch(err)
        {
            return {"httpStatusCode": "", "hasError": true, "messages": ["Unexpected error fetching all receipts.", err.name, err.message], "dataResult": null};
        }
    }



    async addReceipt(gcid, receipt, offlineId)
    {
        try
        {
            receipt.ReceiptSnapshot = JSON.stringify(receipt);
            var res = (await this.idb.gcrDb).add('gcReceipt', receipt, offlineId);
            return {"httpStatusCode": "200", "hasError": false, "messages": ["local receipt added"], "dataResult": res};
        }
        catch(err)
        {
            return {"httpStatusCode": "", "hasError": true, "messages": ["Unexpected error fetching adding receipt.", err.name, err.message], "dataResult": null};
        }
        
    }

    async deleteReceipt(offlineId)
    {
        try
        {
            var res = await (await this.idb.gcrDb).delete("gcReceipt", offlineId);
            return {"httpStatusCode": "200", "hasError": false, "messages": ["local receipt deleted"], "dataResult": res};

        }
        catch(err)
        {
            return {"httpStatusCode": "", "hasError": true, "messages": ["Unexpected error fetching deleting receipt.", err.name, err.message], "dataResult": null};
        }
        
    }


    async getNextTag()
    {
        var localDataService = new LocalDbService();
        var allReceipts = await localDataService.fetchAllReceipts();
        var count = allReceipts.length + 1;
        return 1000 + count;
    }

}



